import React from 'react';
import { motion } from 'framer-motion';
import heroBg from '../assets/hero-final-v2.jpg';

const Hero = () => {
    return (
        <section className="relative min-h-[60vh] md:h-screen flex items-center justify-center overflow-hidden bg-slate-50 pt-28 pb-16 md:py-0">
            {/* Background Image - Artırılmış Bulanıklık (3px) */}
            <div className="absolute inset-0 z-0">
                <img
                    src={heroBg}
                    alt="Background"
                    className="w-full h-full object-cover opacity-80 blur-[3px] scale-105"
                    loading="eager"
                    fetchpriority="high"
                />
                {/* Modern Blue Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0f172a]/60 via-transparent to-transparent" />
            </div>

            {/* Content - Centered Slogan */}
            <div className="relative z-20 text-center max-w-5xl mx-auto px-4 sm:px-6">
                <motion.h1
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.2 }}
                    className="text-3xl sm:text-5xl md:text-8xl font-extrabold tracking-tight leading-none drop-shadow-2xl text-center mx-auto"
                >
                    <span className="block text-yellow-300 mb-2 drop-shadow-md">BİLGİYLE GEZİ,</span>
                    <span className="bg-gradient-to-r from-cyan-400 via-emerald-400 to-cyan-400 bg-clip-text text-transparent animate-gradient-x drop-shadow-none pb-2 block sm:inline">
                        TUTKUYLA REHBERLİK!
                    </span>
                </motion.h1>
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1, duration: 1 }}
                    className="text-cyan-200 mt-4 sm:mt-6 text-sm sm:text-xl md:text-3xl tracking-wider sm:tracking-widest font-bold uppercase text-center drop-shadow-sm"
                >
                    Muğla Sıtkı Koçman Üniversitesi <br />
                    <span className="text-white/90 font-extrabold">Turist Rehberliği Topluluğu</span>
                </motion.p>
            </div>

            {/* Dalga (Wave) Çizgisi Tamamen Kaldırıldı - Düz Geçiş İçin */}
        </section>
    );
};

export default Hero;
